module.exports = __webpack_public_path__ + "img/img17.8103fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img17.png
// module id = 224
// module chunks = 0